import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'dm-fieldset-header',
    templateUrl: 'dm-fieldset-header.component.html',
    styleUrls: ['dm-fieldset-header.component.scss'],
})
export class DmFieldsetHeaderComponent implements OnInit {
    @Input() public backGround;

    public ngOnInit(){

    }
}


